import { render } from "./TipFeesInfoRecipient.vue?vue&type=template&id=f3e59f7c&scoped=true"
import script from "./TipFeesInfoRecipient.vue?vue&type=script&lang=js"
export * from "./TipFeesInfoRecipient.vue?vue&type=script&lang=js"

import "./TipFeesInfoRecipient.vue?vue&type=style&index=0&id=f3e59f7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e59f7c"]])

export default __exports__